<h2 mat-dialog-title class="dialog-header">{{'locker.category.details.title'|traduccion}} {{data?.category?.id}}
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content mat-typography">

    <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1" [colWidths]="[100]">
            <mat-card>
                <h3>{{'locker.category.details.form.info'|traduccion}}</h3>

                <!--
                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.category.details.form.id.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="id" [readonly]="!isNew" />
                    <mat-hint>{{'locker.category.details.form.id.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('id')" ></app-form-error>
                </mat-form-field>
                -->

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.category.details.form.parentId.label'|traduccion}}</mat-label>
                    <mat-select formControlName="parentId">
                        <mat-option [value]="null">{{'locker.category.details.form.parentId.default'|traduccion}}</mat-option>
                        <mat-option *ngFor="let category of data.categories" [value]="category.id">{{category.code}}</mat-option>
                    </mat-select>
                    <mat-hint>{{'locker.category.details.form.parentId.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('parentId')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.category.details.form.code.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="code" />
                    <mat-hint>{{'locker.category.details.form.code.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('code')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.category.details.form.image.label'|traduccion}}</mat-label>

                    <img [src]="imagePreview" alt="Vista previa" style="max-width: 200px; border-radius: 8px;">
                    <img
                    [src]="data?.category?.imageMedium"
                    [srcset]="
                        data?.category?.imageSmall + ' 200w,
                        ' + data?.category?.imageMedium + ' 400w,
                        ' + data?.category?.imageLarge + ' 800w'
                    "
                    />
                    <input matInput formControlName="imageName">
                    <!-- Input de archivo con referencia y evento -->
                    <input type="file" 
                            (change)="onFileSelected($event)" 
                            accept="image/*" >

                    <mat-hint>{{'locker.category.details.form.image.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('image')" ></app-form-error>
                </mat-form-field>

                

                <div class="flex items-center col-span-2">
                    <mat-checkbox formControlName="enabled">{{'locker.category.details.form.enabled.label'|traduccion}}</mat-checkbox>
                </div>
            </mat-card>

            <mat-card>
                <h3>{{'locker.category.details.form.literals'|traduccion}}</h3>

                <mat-accordion>
                    <mat-expansion-panel *ngFor="let key of literalkeys"  hideToggle>
                        <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{key}}
                        </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-translation-editor
                            [literals]="literals"
                            literalKey="{{key}}"
                            (literalsChange)="onLiteralsUpdated($event)">
                        </app-translation-editor>
                    </mat-expansion-panel>
                </mat-accordion>
            </mat-card>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-footer">
    <span class="spacer"></span>
    <button mat-flat-button color="primary" [disabled]="!form.valid"
        (click)="confirm()">{{'locker.category.details.action.save'|traduccion}}</button>
    <button *ngIf="!isNew" mat-stroked-button color="warn"
        (click)="delete()">{{'locker.category.details.action.delete'|traduccion}}</button>
</mat-dialog-actions>